import styled from "styled-components/macro";

export const StyledHeader = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  ${"" /* margin: 40px 0; */}
  & h2 {
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 48px;
    letter-spacing: 0em;
    color: #575e68;
    margin: 16px 0;
  }
  & p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    color: #575e68;
  }
`;

export const StyledSupportCard = styled.div`
  font-style: normal;
  font-weight: 600;
  text-align: left;
  background: #ffffff;
  border: 1px solid #ebedee;
  border-radius: 8px;
  padding: 2rem;
  margin: 40px auto;
  max-width: 700px;
`;

export const StyledTag = styled.p`
  text-transform: uppercase;
  font-size: 12px;
  line-height: 18px;
  color: #6270c6;
  background: rgba(98, 112, 198, 0.1);
  border-radius: 4px;
  display: inline-block;
  padding: 4px 8px;
  margin-bottom: 8px;
`;

export const StyledArticleTitle = styled.h2`
  color: #111111;
  font-size: 24px;
  line-height: 36px;
  margin: 8px 0;
`;

export const StyledSnippet = styled.div`
  font-weight: normal;
  line-height: 24px;
  color: #575e68;
  opacity: 0.8;
  margin-bottom: 24px;
  text-align: justify;
  p {
    margin-top: 10px;
  }
  ol {
    margin-bottom: 10px;
    padding: 0;
    list-style: decimal outside none;
  }
`;

export const StyledLink = styled.a`
  font-size: 12px;
  line-height: 18px;
  color: #6270c6;
  text-decoration: none;
  border-bottom: 2px solid #6270c6;
`;

export const StyledList = styled.ul`
  padding: 0;
  list-style: none;
`;
